import BaseDocumentHead, { IDocumentHead } from 'components/DocumentHead'
import { inject } from 'helpers/mobx'
import TrackContentPageView from 'helpers/tracking/trackerComponents/TrackContentPageView'
import React from 'react'
import { IStoreProvider } from 'store'
import { prepareDescription } from './helpers'

const DocumentHead: React.FC<Partial<IDocumentHead>> = props => {
  return (
    <>
      <TrackContentPageView pageTitle={props.title || ''} />
      <BaseDocumentHead {...props} />
    </>
  )
}

export default inject((store: IStoreProvider) => {
  const { title, name, metaDescription, metaRobots } = store.seoStreamPageStore
  const { t } = store
  const { currentPage } = store.searchPageStore.pagination

  return {
    title:
      title ||
      t('{{outfitName}} online kaufen | ABOUT YOU', {
        outfitName: name,
      }),
    description: metaDescription || prepareDescription({ title: name, t }),
    robots: currentPage > 1 ? 'noindex, follow' : metaRobots,
    customTitleTemplate: true,
  }
})(DocumentHead)
